import React from 'react'
import Image from 'next/image'

import { Column, Row, Rows } from '@/components/layout'
import guaranteeBadgeImg from '@/assets/buy-flow/right-side/cc--guarantee-badge.png'

import styles from './CheckoutSideCreditCardTrial.module.scss'

export default function CheckoutSideCreditCardTrial() {
  return (
    <Column className={styles.background} gap={32} size={66}>
      <div className={styles.pinkBox}>
        <Row className={styles.headerRow} gap={0}>
          <Column size={66}>
            <Rows className="max-w-500" gap={0}>
              <h1 className={`${styles.headLine} ${styles.headLineSpacing}`}>You're Almost Ready to Start Your Trial</h1>
              <h2 className={styles.headLine}>Neat's Promise</h2>
            </Rows>
          </Column>
          <Column size={33}>
            <Image alt="30-day money back guarantee" src={guaranteeBadgeImg} style={{ height: 'auto' }} width={300} />
          </Column>
        </Row>
        <Row className={styles.textRow}>
          <Column>
            <p className={styles.promiseBlock}>While we ask for a credit card to sign up, the 14-day trial is indeed free, and you will not be charged during the trial period.</p>
          </Column>
          <Column>
            <p className={styles.promiseBlock}>Throughout the trial period, we will remind you when the trial is ending, and it can be cancelled at any time, free of charge.</p>
          </Column>
          <Column>
            <p className={styles.promiseBlock}>We also offer a full 30-day money-back guarantee following the trial should Neat not be the right solution for you.</p>
          </Column>
        </Row>
        <div className={styles.fiveMin}>Set up in 5 minutes</div>
      </div>
    </Column>
  )
}
